export const LINKS: LinkList[] = [
  {
    href: 'https://www.google.com',
    label: 'Contato',
  },
  {
    href: 'https://www.google.com',
    label: 'Modelos',
  },
  {
    href: 'https://www.google.com',
    label: 'Quem somos',
  },
];
